export default "__VITE_ASSET__DYmscHvL__"